module.exports = __webpack_public_path__ + "static/img/033_TO8_1515.2d700ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/033_TO8_1515.jpg
// module id = lPUW
// module chunks = 0